export { default } from './RatingInput';